export const COLOR_PRODUCT_NUMBER_PARAM = 'colorProductNumber';
export const COLOR_NAME_PARAM = 'colorName';

export const COLOR_ID_QUERY_PARAM = 'color_id';
